import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

export const translatedTitle = (key: string): ResolveFn<string> => {
  return () => {
    const translate = inject(TranslateService);

    return firstValueFrom(translate.get(key));
  };
};
